/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_IncotermInputs */

const en_reference_dataset_incoterm = /** @type {(inputs: Reference_Dataset_IncotermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incoterms`)
};

/**
* | output |
* | --- |
* | "Incoterms" |
*
* @param {Reference_Dataset_IncotermInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_incoterm = /** @type {((inputs?: Reference_Dataset_IncotermInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_IncotermInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_incoterm(inputs)
});